// extracted by mini-css-extract-plugin
export default {"root":"uVFvG8IU","info":"YkVjS9Dm","email":"HmiFffRJ"};